/* eslint-disable */
import React, { Suspense, useState, useEffect  } from "react";
import { render } from "react-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
// redux
import LoadingScreen from "react-loading-screen";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { ChakraProvider, ColorModeProvider } from "@chakra-ui/react";
import theme from "./theme";
export const browserHistory = createBrowserHistory();
import "./assets/vendor/nucleo/css/nucleo.css";
import "./assets/scss/global.scss";
import "./assets/scss/argon-dashboard-react.scss";
import "./assets/css/custom.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";
import axios from "axios";
import { loginUri, envHost } from "./utils/uri";
import Cookies from "js-cookie";
import store from "./utils/store";
import i18n from "./utils/i18n";
import { PrivateRoute } from "./utils/Routes/PrivateRoute";
import { I18nextProvider } from "react-i18next";
import { initAxiosFund } from "./utils/store/actions/funds.actions";
import { initAxiosNotification } from "./utils/store/actions/toasts.actions";

const Root = () => {
  const [accessTokenCookie, setAccessTokenCookie] = useState(Cookies.get("accessToken"));

  if (accessTokenCookie) {
    axios.defaults.headers.common["X-Jwt"] = accessTokenCookie;
  }
  useEffect(() => {
    const fetchToken = async () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const accessToken = urlParams.get("access_token");

        if (accessToken !== undefined && accessToken !== null) {
          Cookies.remove("authToken");
          Cookies.set("accessToken", accessToken);
          const accessCookie = Cookies.get("accessToken");
          if (accessCookie) {
            axios.defaults.headers.common["X-Jwt"] = accessCookie;
          }
          setAccessTokenCookie(accessCookie);
        } else {
          if (!Cookies.get("accessToken")) {
            window.location.href = `${loginUri}${envHost}`;
          }
        }
    };
    fetchToken();
  }, []);

  if (!accessTokenCookie) {
    console.info("Loading...");
    return null;
  }
  initAxiosFund();
  initAxiosNotification();

  return (<BrowserRouter>
               <I18nextProvider i18n={i18n}>
                 <ChakraProvider resetCSS theme={theme}>
                   <ColorModeProvider
                     options={{
                       initialColorMode: "light",
                       useSystemColorMode: false,
                     }}
                   >
                     <Suspense fallback={<LoadingScreen />}>
                       <Provider store={store}>
                         <Switch>
                           <PrivateRoute
                             // exact
                             path="/admin"
                             isAuthenticated={
                               !!accessTokenCookie
                             }
                             render={(props: any) => <AdminLayout {...props} />}
                           />
                           {accessTokenCookie && (
                             <Route
                               path="/"
                               render={(props) => <AdminLayout {...props} />}
                             >
                               <Redirect to="/admin/index" />
                             </Route>
                           )}
                           <Route
                             path="/auth"
                             render={(props) => <AuthLayout {...props} />}
                           />
                         </Switch>
                       </Provider>
                     </Suspense>
                   </ColorModeProvider>
                 </ChakraProvider>
               </I18nextProvider>
             </BrowserRouter>);
};

const rootElement = document.getElementById("root");

render(<Root />,rootElement);
